import React, { useState, useEffect } from 'react';

export function Sidebar({ seccionActiva, setSeccionActiva, subeMenuAbierto, toggleSubMenu, usuario, onLogout }) {
  return (
    <div className="sidebar">
      <div className="sb-logo">
        <div className="sb-logo-mark" onClick={() => setSeccionActiva('accesos')} style={{ cursor: 'default', userSelect: 'none' }}>SIGRH</div>
      </div>

      <div className="sb-profile">
        <div className="sb-avatar">{usuario.name.charAt(0)}</div>
        <div>
          <div className="sb-pname">{usuario.name}</div>
          <div className="sb-prole">Sistema Integral RH</div>
        </div>
      </div>

      <nav className="sb-nav">
        <div className="sb-section">
          <div
            className={`sb-item ${seccionActiva === 'dashboard' ? 'active' : ''}`}
            onClick={() => setSeccionActiva('dashboard')}
          >
            <i className="ti ti-layout-dashboard"></i>
            <span>Dashboard</span>
          </div>
        </div>

        <div className="sb-section">
          <div className="sb-label">Personal</div>
          <div
            className={`sb-item ${['empleados-activos', 'empleados-bajas'].includes(seccionActiva) ? 'open' : ''}`}
            onClick={() => toggleSubMenu('empleados')}
          >
            <i className="ti ti-users"></i>
            <span>Empleados</span>
            <span className="chev">›</span>
          </div>

          <div className={`submenu ${subeMenuAbierto.empleados ? 'open' : ''}`}>
            <div
              className={`sub-item ${seccionActiva === 'empleados-activos' ? 'active' : ''}`}
              onClick={() => setSeccionActiva('empleados-activos')}
            >
              <span className="sub-dot"></span>
              <span>Activos</span>
            </div>
            <div
              className={`sub-item ${seccionActiva === 'empleados-bajas' ? 'active' : ''}`}
              onClick={() => setSeccionActiva('empleados-bajas')}
            >
              <span className="sub-dot"></span>
              <span>Bajas</span>
            </div>
          </div>

          <div
            className={`sb-item ${seccionActiva === 'capacitaciones' ? 'active' : ''}`}
            onClick={() => setSeccionActiva('capacitaciones')}
          >
            <i className="ti ti-school"></i>
            <span>Capacitaciones</span>
          </div>
        </div>

        <div className="sb-section">
          <div className="sb-label">Nómina</div>
          <div
            className={`sb-item ${['cambios-pendientes', 'cambios-confirmados'].includes(seccionActiva) ? 'open' : ''}`}
            onClick={() => toggleSubMenu('cambios')}
          >
            <i className="ti ti-settings"></i>
            <span>Cambios Intellisis</span>
            <span className="chev">›</span>
          </div>

          <div className={`submenu ${subeMenuAbierto.cambios ? 'open' : ''}`}>
            <div
              className={`sub-item ${seccionActiva === 'cambios-pendientes' ? 'active' : ''}`}
              onClick={() => setSeccionActiva('cambios-pendientes')}
            >
              <span className="sub-dot"></span>
              <span>Pendientes</span>
            </div>
            <div
              className={`sub-item ${seccionActiva === 'cambios-confirmados' ? 'active' : ''}`}
              onClick={() => setSeccionActiva('cambios-confirmados')}
            >
              <span className="sub-dot"></span>
              <span>Confirmados</span>
            </div>
          </div>
        </div>

        <div className="sb-section">
          <div className="sb-label">Reclutamiento</div>
          <div
            className={`sb-item ${seccionActiva === 'reclutamiento' ? 'active' : ''}`}
            onClick={() => setSeccionActiva('reclutamiento')}
          >
            <i className="ti ti-briefcase"></i>
            <span>Reclutamiento</span>
          </div>
        </div>

        <div className="sb-section">
          <div className="sb-label">Importación</div>
          <div
            className={`sb-item ${seccionActiva === 'importacion-intellisis' ? 'active' : ''}`}
            onClick={() => setSeccionActiva('importacion-intellisis')}
          >
            <i className="ti ti-file-import"></i>
            <span>Importación Intellisis</span>
          </div>
        </div>

        <div className="sb-section">
          <div className="sb-label">Desempeño</div>
          <div
            className={`sb-item ${seccionActiva === 'evaluaciones' ? 'active' : ''}`}
            onClick={() => setSeccionActiva('evaluaciones')}
          >
            <i className="ti ti-clipboard-check"></i>
            <span>Evaluaciones</span>
          </div>
        </div>

        <div className="sb-section">
          <div className="sb-label">Servicios</div>
          <div
            className={`sb-item ${seccionActiva === 'comedor' ? 'active' : ''}`}
            onClick={() => setSeccionActiva('comedor')}
          >
            <i className="ti ti-bowl"></i>
            <span>Comedor</span>
          </div>
        </div>
      </nav>

      <div className="sb-footer">
        <button className="sb-logout" onClick={onLogout}>
          <i className="ti ti-logout"></i>
          <span>Salir</span>
        </button>
      </div>
    </div>
  );
}

export function Topbar({ usuario }) {
  const [hora, setHora] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setHora(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const horaFormato = hora.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });

  return (
    <div className="topbar">
      <div className="breadcrumb">
        <span>Inicio</span> / <span>Portal RH</span>
      </div>
      <div style={{ flex: 1 }}></div>
      <div className="search-wrap">
        <i className="ti ti-search"></i>
        <input type="text" placeholder="Buscar..." />
      </div>
      <div className="hora-display">
        <div className="hora-valor">{horaFormato}</div>
        <div className="hora-label">Hora actual</div>
      </div>
      <div className="tb-actions">
        <div className="ib">
          <i className="ti ti-bell"></i>
          <span className="ndot"></span>
        </div>
        <div className="ib">
          <i className="ti ti-settings"></i>
        </div>
        <div className="uav">{usuario.name.charAt(0)}</div>
      </div>
    </div>
  );
}
